<script>
export default {
  props: {
    icon: {
      required: true,
      type: String
    }
  },

  functional: true,

  render(h, { data, props }) {
    return h('div', {
      class: data.staticClass,
      staticClass: "inline-block",
      staticStyle: data.staticStyle,
      domProps: {
        innerHTML: require('!html-loader!../../assets/site/svg/' + props.icon + '.svg')
      }
    })
  }
}
</script>
